const de = {
    login: "Anmelden",
    logout: "Abmelden",
    signIn: "Einloggen",
    signOut: "Abmelden",
    profile: "Profil",
    settings: "Einstellungen",
    digiAirMenuWaiterLogin: "DigiAirMenu Kellner-Login",
    appLogoAlt: "digiAirMenu-Logo",
    username: "Nutzername",
    password: "Passwort",
    pinCode: "PIN",
    yourAuthenticationFailed: "Anmeldung fehlgeschlagen",
    addDAMToHomeScreen: "DigiAirMenu zum Startbildschirm hinzufügen",
    addToHomeScreen: "Zum Startbildschirm hinzufügen",
    installDAM: "DAM installieren",
    language: "Sprache",
    chooseLanguage: "Sprache wählen",
    pageNotFound: "Seite nicht gefunden",
    backToDashboard: "Zurück zum Dashboard",
    transferToDemo: "Zu Demo wechseln",
    transferToLive: "Zu Live wechseln",
    currentTable: "Aktuelle Tabelle",
    table: "Tisch",
    tables: "Tische",
    order: "Bestellung",
    orders: "Bestellungen",
    option: "Option",
    additive: "Zusatz",
    options: "Optionen",
    additives: "Zusätze",
    empty: "Leer",
    row: "Zeile",
    count: "Anzahl",
    step: "Schritt",
    title: "Titel",
    untitledItem: "Ohne Titel",
    createdAt: "Erstellt am",
    free: "Gratis",
    freeItems: "Gratisartikel",
    items: "Artikel",
    item: "Artikel",
    itemsCountOfAll: "{{payCount}} von {{maxCount}}",
    minimum: "Minimum",
    maximum: "Maximum",
    min: "min",
    max: "max",
    all: "Alle",
    unitPrice: "Einzelpreis",
    email: "Email",
    print: "Drucken",
    printingFailed: "Drucken fehlgeschlagen!",
    checkoutPrintDataUnavailable: "Zahlungsbelegdaten zum Drucken sind nicht verfuegbar",
    printUsingExternalDevice: "Mit externem Gerät drucken",
    orderDetails: "Bestelldetails",
    noOrders: "Keine Bestellungen",
    noOrdersAdded: "Keine Bestellungen hinzugefügt",
    noAddedItems: "Es wurden keine Artikel hinzugefügt",
    loading: "Wird geladen",
    createOrSelectOrderAfterSelectingTable: "Zuerst einen Tisch wählen, dann eine Bestellung erstellen oder öffnen",
    createOrSelectOrderFirst: "Zuerst eine Bestellung erstellen oder öffnen",
    customFood: "Individueller Artikel",
    customFoods: "Individuelle Artikel",
    normalFoodOrDrink: "Speise/Getränk",
    customMenuItems: "Individuelle Artikel",
    sentToKitchen: "In die Küche geschickt",
    sendToKitchen: "In die Küche schicken",
    orderDelivered: "Bestellung geliefert",
    orderDeliveredConfirmation: "Sind Sie sicher, dass diese Bestellung geliefert wurde?",
    selectItemsForSendingToKitchen: "Artikel für die Küche wählen",
    type: "Typ",
    status: "Status",
    ItemDetailsAndStatus: "Artikeldetails / Status",
    description: "Beschreibung",
    typeAnythingYouNeed: "Beliebigen Text eingeben",
    paid: "bezahlt",
    partiallyPaid: "Teilweise bezahlt",
    unpaid: "unbezahlt",
    pending: "Ausstehend",
    canceled: "Storniert",
    created: "Erstellt",
    accepted: "Akzeptiert",
    arrival: "Ankunft",
    late_arrival: "Verspätete Ankunft",
    late_pickup: "Verspätete Abholung",
    request_new_driver: "Neuen Fahrer anfordern",
    shipment_destroyed: "Sendung beschädigt",
    address_not_found: "Adresse nicht gefunden",
    completed: "Abgeschlossen",
    late_completed: "Verspätet abgeschlossen",
    isPaid: "Bezahlt",
    total: "Gesamt",
    editOrderItem: "Bestellposition bearbeiten",
    chooseTable: "Tisch wählen",
    pickup: "Abholung",
    suspended: "Zurückgestellt",
    processing: "In Arbeit",
    rejected: "Abgelehnt",
    delivered: "Geliefert",
    ordersList: "Bestellliste",
    showOlderOrders: "Ältere Bestellungen anzeigen",
    showHistory: "Verlauf anzeigen",
    showCanceledOrders: "Stornierte Bestellungen anzeigen",
    showDeliveredOrders: "Ausgelieferte Bestellungen anzeigen",
    showPaidOrders: "Bezahlte Bestellungen anzeigen",
    listOfOrders: "Liste der Bestellungen",
    listOfolderOrRejectedOrdersTitle: "Ältere/Abgelehnte",
    addNewOrder: "Neue Bestellung hinzufügen",
    ordering: "Bestellung",
    availableFoods: "Speisen & Getränke",
    searchByTableName: "Tisch suchen",
    Layout: "Layout",
    gridView: "Rasteransicht",
    listView: "Listenansicht",
    Filters: "Filter",
    availableItems: "Verfügbare Artikel",
    searchByFoodName: "Artikel suchen",
    allCategories: "Alle Kategorien",
    noCategories: "Keine Kategorien",
    addFood: "Artikel hinzufügen",
    editManualItem: "Manuellen Eintrag bearbeiten",
    addManualItem: "Manuellen Artikel hinzufügen",
    manualItem: "Manueller Artikel",
    manualItems: "Manuelle Artikel",
    areYouSureYouWantToConvertOrderToDemoModeOrder: "Möchten Sie Bestellung <1>{{orderId}}</1> wirklich in eine Demo-Bestellung umwandeln?",
    areYouSureYouWantToConvertOrderToLiveModeOrder: "Möchten Sie Bestellung <1>{{orderId}}</1> wirklich in eine Live-Bestellung umwandeln?",
    areYouSureYouWantToSwitchToLiveMode: "Möchten Sie wirklich in den Live-Modus wechseln?",
    areYouSureYouWantToSwitchToDemoMode: "Möchten Sie wirklich in den Demo-Modus wechseln?",
    areYouWantDeleteThisItem: "Diesen Artikel wirklich löschen?",
    areYouWantCancelOrder: "Diese Bestellung wirklich stornieren?",
    getEmailLabel: "Bitte E-Mail eingeben",
    enterValidEmailErr: "Bitte eine gültige E-Mail-Adresse eingeben.",
    sendEmail: "E-Mail senden",
    send: "Senden",
    sendReceiptInfo: "Belegdetails senden",
    resendPaymentLink: "Zahlungslink erneut senden",
    sendMenuSms: "Menü-Link senden",
    sendMenuLinkBySms: "Menü-Link per SMS senden",
    menuLinkSentSuccessfully: "Menü-Link erfolgreich gesendet",
    paymentLinkResentSuccessfully: "Zahlungslink erfolgreich gesendet",
    receiverEmail: "Empfänger-E-Mail",
    receiverPhone: "Empfängertelefon",
    receiverEmailPlaceholder: "beispiel@email.com",
    emailIsRequired: "E-Mail ist erforderlich",
    phoneNumberIsRequired: "Telefonnummer ist erforderlich",
    emailOrPhoneIsRequired: "E-Mail oder Telefonnummer ist erforderlich",
    invalidEmailFormat: "Ungültiges E-Mail-Format",
    iUnderstand: "Ich verstehe",
    no: "Nein",
    yes: "Ja",
    cancel: "Abbrechen",
    close: "Schließen",
    back: "Zurück",
    next: "Weiter",
    previous: "Vorherige",
    add: "Hinzufügen",
    preview: "Vorschau",
    changeTable: "Tisch wechseln",
    saveChanges: "Änderungen speichern",
    confirm: "Bestätigen",
    unselectAll: "Alle abwählen",
    selectAll: "Alle wählen",
    selected: "ausgewählt",
    reset: "Zurücksetzen",
    clear: "Leeren",
    mobileKeyboard: "Mobile Tastatur",
    externalDeliveryOrder: "Externe Lieferbestellung",
    externalDeliveryOrderDescription: "Diese Bestellung muss vor der Bearbeitung angenommen werden.",
    waiterDraftOrder: "Vom Kellner erstellte Bestellung",
    waiterDraftOrderDescription: "Diese Bestellung kann noch bearbeitet werden. Bestätigen Sie sie, wenn alles passt.",
    accept: "Annehmen",
    acceptOrder: "Bestellung annehmen",
    confirmOrder: "Bestellung bestätigen",
    completeOrderSetup: "Bestellung abschließen",
    completeOrderSetupDialogTitle: "Lieferdetails ergänzen und Abholzeit festlegen",
    acceptOrderDialogTitle: "Beim Annehmen startet die Zubereitung und die Küche wird informiert",
    confirmOrderDialogTitle: "Beim Bestätigen wird die Bestellung gesperrt und die Zubereitung gestartet",
    acceptOrderExternalDescription: "Diese Bestellung kam extern herein. Annehmen, um die Zubereitung zu starten, oder ablehnen, wenn sie nicht erfüllt werden kann.",
    confirmOrderWaiterCreatedDescription: "Diese Bestellung wurde vom Kellner erstellt. Prüfen und bestätigen Sie sie, sobald alles fertig ist.",
    acceptOrderWaiterCreatedDescription: "Diese Bestellung wurde vom Kellner erstellt. Annehmen, um Änderungen zu sperren und die Zubereitung zu starten.",
    editingLockedForCustomerOrder: "Kundenbestellungen können nicht bearbeitet werden.",
    editingLockedForRejectedOrder: "Diese Bestellung wurde abgelehnt und kann nicht mehr bearbeitet werden.",
    editingLockedCustomerOrderAfterAcceptance: "Kundenbestellungen können nach der Annahme nicht mehr bearbeitet werden.",
    editingLockedAfterConfirmation: "Nach der Bestätigung kann die Bestellung nicht mehr bearbeitet werden.",
    editingDoneOrderItemLocked: "Bereits erledigte Bestellpositionen können nicht mehr geändert werden.",
    editingPaidOrderItemLocked: "Bereits bezahlte Bestellpositionen können nicht mehr geändert werden.",
    editingPendingPaymentOrderItemLocked: "Diese Bestellposition kann während der Zahlungsbearbeitung nicht geändert werden.",
    editingSentToKitchenItemLockedByPermission: "Sie haben keine Berechtigung, bereits an die Kuche gesendete Bestellpositionen zu andern.",
    rejectOrder: "Bestellung ablehnen",
    rejectOrderConfirm: "Diese Bestellung wirklich ablehnen?",
    acceptOrderPickupTimeHelperText: "Die Abholzeit kann um bis zu <1>30 Minuten</1> verschoben werden",
    pleaseEnterPickupTime: "Bitte eine Abholzeit eingeben.",
    addToOrders: "Zur Bestellung",
    cancelThisOrder: "Diese Bestellung stornieren",
    cancelOrder: "Bestellung stornieren",
    orderModeChangedToDemoInJSX: "Der Bestellmodus wurde für '<1>Bestellung {{targetOrderId}}</1>' auf Demo geändert.",
    orderModeChangedToLiveInJSX: "Der Bestellmodus wurde für '<1>Bestellung {{targetOrderId}}</1>' auf Live geändert.",
    checkoutHasPaidByPosInJSX: "Der <1>Kassenvorgang</1> mit der ID <3>{{checkout_id}}</3> aus <5>Bestellung {{order_id}}</5> wurde erfolgreich über POS bezahlt.",
    demo: "Demo",
    demoModeIsActive: "Demo-Modus ist aktiv",
    demoModeAlertMessage: "Der Demo-Modus dient ausschließlich zu Schulungs- und Testzwecken. Für die Nutzung und Einhaltung aller gesetzlichen Vorschriften während des Demo-Modus ist ausschließlich der Restaurantbetreiber verantwortlich.",
    normal: "Normal",
    showOrderInTargetMode: "Bestellung im {{targetMode}}-Modus anzeigen",
    showOrder: "Bestellung anzeigen",
    openOrderInBackground: "<0>Öffnen</0> <1>(im Hintergrund)</1>",
    incomingOrderNotificationTitle: "Neue Bestellung eingegangen",
    incomingOrderNotificationDescription: "Eine Kundenbestellung ist eingegangen. Unten können Sie sie im Hintergrund öffnen, ohne dieses Fenster zu schließen.",
    yesDeleteIt: "Ja, löschen",
    pay: "Zahlen",
    payment: "Zahlung",
    payments: "Zahlungen",
    payReport: "Zahlungsbericht",
    paymentOf: "Zahlung für",
    checkoutOperation: "Kassenvorgang",
    itemsToPay: "Zu bezahlende Artikel",
    price: "Preis",
    basicPrice: "Grundpreis",
    totalPrice: "Gesamtpreis",
    baseAmount: "Grundbetrag",
    paidPrice: "Bezahlt",
    paidBy: "Bezahlt von",
    discount: "Rabatt",
    discountAmount: "Rabattbetrag",
    tipPrice: "Trinkgeld",
    totalWithTip: "Summe inkl. Trinkgeld",
    amountToPay: "Zu zahlender Betrag",
    paymentAmount: "Zahlungsbetrag",
    paymentsIncludingDiscounts: "Zahlungen inkl. Rabatt",
    paymentsExcludingDiscounts: "Zahlungen exkl. Rabatt",
    paymentsTakingIntoAccountTheirDiscount: "Zahlungen mit Rabatt",
    paymentsRegardlessOfTheirDiscount: "Zahlungen ohne Rabatt",
    openPaymentsStatistics: "Statistik offener Zahlungen",
    discountCannotBeLessThanZero: "Der Rabattbetrag darf nicht kleiner als \"0\" sein.",
    discountCannotBeNegative: "Der Rabattbetrag darf nicht negativ sein",
    discountCannotBeMoreThanHundredPercent: "Der Rabattbetrag darf nicht mehr als \"100%\" betragen.",
    discountCannotBeMoreThan: "Der Rabattbetrag darf nicht mehr als {{price}} betragen",
    theValueMustBeMoreThan: "Der Wert muss mehr als {{price}} betragen",
    theValueMustBeMoreThanBaseAmount: "Der Wert muss größer als der Grundbetrag sein",
    valueMustBeLessThanOrEqualToMessage: "Der Wert muss kleiner oder gleich {{maxPrice}} sein",
    valueMustBeGreaterThanZeroMessage: "Der Wert muss größer als 0 sein",
    tip: "Trinkgeld",
    tipAmount: "Trinkgeldbetrag",
    tipCannotBeNegative: "Der Trinkgeldbetrag darf nicht negativ sein",
    payByCreditCard: "Mit Karte zahlen",
    payInCash: "Bar zahlen",
    cardTransfer: "Kartenüberweisung",
    checkout: "Kassa",
    transaction: "Transaktion",
    noTransactionHasBeenMade: "Keine Transaktion vorhanden",
    backToTransactionsList: "Zurück zur Transaktionsliste",
    transactionsHistory: "Transaktionsverlauf",
    transactionDetails: "Transaktionsdetails",
    transactionId: "Transaktions-ID",
    transactionHasBeenSentToYourEmail: "Die Transaktion wurde an Ihre E-Mail-Adresse gesendet",
    paymentType: "Zahlungsart",
    paymentStatus: "Zahlungsstatus",
    ordersPrice: "Bestellsumme",
    totalAmount: "Gesamtbetrag",
    updatedAt: "Aktualisiert am",
    fromTime: "Von",
    toTime: "Bis",
    backToOrders: "Zurück zu Bestellungen",
    tablesList: "Tischliste",
    backToTablesList: "Zurück zur Tischliste",
    showDetails: "Details anzeigen",
    receiptDetailsPage: "Belegdetails",
    checkoutQrCodeAlt: "Kassa-QR-Code",
    vat: "MwSt",
    net: "Netto",
    tax: "Steuer",
    gross: "Brutto",
    sendingEmailFailed: "E-Mail-Versand fehlgeschlagen!",
    paymentFailed: "Zahlung fehlgeschlagen",
    openPayments: "Offene Zahlungen",
    Open_Payments: "Offene Zahlungen",
    openPaymentsReport: "Bericht offener Zahlungen",
    report: "Bericht",
    openPaymentStatistics: "Zahlungsstatistik öffnen",
    allOrderItemsHaveBeenPaid: "Alle Artikel dieser Bestellung wurden bezahlt",
    noItemsHaveBeenAddedInThisOrder: "In dieser Bestellung wurden keine Artikel hinzugefügt",
    thisItemPaymentIsAwaitingConfirmation: "Die Zahlung dieses Artikels wartet auf Bestätigung",
    yourOrderPaymentIsAwaitingConfirmation: "Für diese Bestellung wartet eine Zahlung auf Bestätigung",
    editableInTime: "Editierbar in {{minutes}} Min {{seconds}} Sek",
    thisItemHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "Dieser Artikel wurde über POS bezahlt und wartet auf die Zahlungsbestätigung",
    yourOrderHasBeenPaidThroughPOSAndIsAwaitingPaymentConfirmation: "Ihre Bestellung wurde über POS bezahlt und wartet auf die Zahlungsbestätigung",
    generalSettings: "Allgemeine Einstellungen",
    customItems: "Individuelle Artikel",
    printMethod: "Druckmethode",
    singlePrintMethodDescription: "Es ist immer nur eine Druckmethode gleichzeitig aktiv",
    printMethodBrowser: "Browser-Druckdialog",
    printMethodBluetooth: "Bluetooth-Drucker",
    printMethodUsb: "USB-Drucker (Experimentell)",
    printMethodExternal: "Externer Drucker / App",
    bluetoothUnavailable: "Bluetooth ist in diesem Browser oder auf diesem Gerät nicht verfügbar",
    bluetoothSecureContextRequired: "Bluetooth-Druck erfordert HTTPS oder localhost",
    bluetoothPrinterNotSupported: "Der ausgewählte Bluetooth-Drucker wird nicht unterstützt",
    noBluetoothPrinterSelected: "Es wurde kein Bluetooth-Drucker ausgewählt",
    noCompatibleBluetoothPrinterFound: "Es wurde kein kompatibler Bluetooth-Drucker gefunden oder ausgewählt. Browser erkennen meist nur BLE/GATT-Drucker, daher erscheinen klassische Bluetooth-Modelle wie Epson TM-m30 hier oft nicht",
    bluetoothAutoPrintRequiresSelection: "Wählen Sie den Bluetooth-Drucker einmal manuell aus, bevor automatisches Drucken verwendet werden kann",
    bluetoothPrintingNotSupported: "Bluetooth-Druck wird auf diesem Browser oder Gerät nicht unterstützt",
    usbUnavailable: "USB ist in diesem Browser oder auf diesem Gerät nicht verfügbar",
    usbSecureContextRequired: "USB-Druck erfordert HTTPS oder localhost",
    noCompatibleUsbPrinterFound: "Es wurde kein kompatibler USB-Drucker gefunden oder ausgewählt",
    usbAccessDenied: "Der Browser oder das Betriebssystem hat den Zugriff auf den ausgewählten USB-Drucker verweigert. Schließen Sie andere Drucker-Apps und prüfen Sie die USB-Berechtigungen des Systems, dann versuchen Sie es erneut",
    usbAutoPrintRequiresSelection: "Wählen Sie den USB-Drucker einmal manuell aus, bevor automatisches Drucken verwendet werden kann",
    usbPrintingNotSupported: "USB-Druck wird für das ausgewählte Gerät nicht unterstützt",
    printerSize: "Druckergröße",
    useExternalPrinter: "Externen Drucker verwenden",
    bluetoothPrinterDetails: "Drucke an Bluetooth-Drucker senden. Ist die Option aus, wählen Sie einen verbundenen Drucker dieses Geräts.",
    usbPrinterDetails: "Best-Effort-Unterstützung für ESC/POS-kompatible USB-Drucker in Desktop-Chrome oder Edge. Möglicherweise muss der Drucker einmal manuell ausgewählt werden, bevor automatisches Drucken ihn verwenden kann. Unter Windows benötigt der Drucker eventuell zusätzlich den Vendor-Class-Modus und einen WinUSB-kompatiblen Treiber, bevor er in der Browserliste erscheint",
    externalPrinterDetails: "Drucke an externe Drucker senden. Ist die Option aus, wählen Sie einen verbundenen Drucker dieses Geräts.",
    autoPrint: "Automatisch drucken",
    autoPrintDescription: "Automatisch drucken nach dem Akzeptieren einer Bestellung oder nach einem Websocket-Ereignis für eine bezahlte Bestellung",
    autoPrintUnavailableForBrowserDescription: "Automatisches Drucken ist beim Browser-Druckdialog nicht verfügbar",
    browserPrintMethodNotice: "Der Browser-Druckdialog erfordert immer eine Bestätigung, daher können Belege nicht automatisch gedruckt werden.",
    selectAllPayablesByDefault: "Alle Positionen vorauswählen",
    selectAllPayablesByDefaultOnThePaymentPage: "Auf der Zahlungsseite standardmäßig alle zahlbaren Positionen auswählen.",
    virtualKeyboard: "Virtuelle Tastatur",
    virtualKeyboardDescription: "Die In-App-Tastatur in unterstützten Formularfeldern verwenden",
    virtualKeyboardInfoLabel: "Tastaturhilfe",
    virtualKeyboardDisableHint: "Wenn Sie lieber die Tastatur Ihres Geräts verwenden möchten, können Sie diese Tastatur in <0>Einstellungen</0> deaktivieren.",
    delivery: "Lieferung",
    deliveryAddress: "Lieferadresse",
    deliveryDetails: "Lieferdetails",
    addDeliveryDetails: "Lieferdetails hinzufügen",
    editDeliveryDetails: "Lieferdetails bearbeiten",
    createDelivery: "Lieferung erstellen",
    fullAddress: "Adresse",
    postalCode: "Postleitzahl",
    houseNumber: "Hausnummer",
    served: "Serviert",
    doorNumber: "Tür",
    apartmentEntrance: "Stiege",
    floor: "Stock",
    extraAddressDetails: "Adresszusatz",
    fullName: "Name",
    dialCode: "Ländervorwahl",
    phoneNumber: "Telefonnummer",
    contactInformationAtPickup: "Kontaktdaten des Empfängers",
    recommended: "empfohlen",
    deliverySummary: "Lieferübersicht",
    Error: "Fehler",
    unexpectedErrorOccurred: "Ein Fehler ist aufgetreten",
    distance: "Entfernung",
    duration: "Dauer",
    minutes: "Minuten",
    deliveryPrice: "Lieferpreis",
    deliveryFee: "Liefergebühr",
    itemsPrice: "Artikelpreis",
    totalReceipt: "Gesamtsumme",
    successfulDeliveryRegistration: "Lieferung erfolgreich registriert",
    successfulSendDelivery: "Lieferung erfolgreich versendet",
    customer: "Kunde",
    withDelivery: "Mit Lieferung",
    deliveryItem: "Lieferartikel",
    pickupDetails: "Abholdetails",
    pickupDate: "Abholdatum",
    pickupTime: "Abholzeit",
    pickupDatetime: "Gewünschte Abholzeit (Datum/Uhrzeit)",
    pickupTimeLabel: "Abholzeit ({{format}})",
    pickupTimeBaseLabel: "Abhol-Startzeit",
    pickupTimeFinalLabel: "Abhol-Endzeit",
    dropOffTime: "Drop-off-Zeit",
    pickupTimeInitialShort: "Start",
    orderTiming: "Zeitplanung",
    requestedPickupDatetime: "Gewählte Abholzeit (Datum/Uhrzeit)",
    timePickerHour: "Stunde",
    timePickerMinute: "Minute",
    toggleTimeList: "Zeitliste umschalten",
    maximumSelectableFreeCountHint: "Max. gratis auswählbar",
    minimumSelectableCountHint: "Mindestens auswählbar",
    maximumSelectableCountHint: "Maximal auswählbar",
    maximumSelectedItemsReached: "Maximale Auswahl erreicht",
    changePickupTime: "Abholzeit ändern",
    pickupTimeAllowedRangeHint: "Für {{date}} ist eine Abholzeit von {{start}} bis {{end}} möglich.",
    pickupDatetimeNotSetHint: "Noch keine Abholzeit gesetzt. Sie können eine beliebige Abholzeit wählen.",
    pickupDatetimeLimitedDelayHint: "Diese Abholzeit kann bis zur Annahme um bis zu <1>30 Minuten</1> verschoben werden.",
    pickupDatetimeLockedHint: "Für diese Bestellung ist bereits eine Abholzeit gesetzt.",
    pickupTimeEditableOnlyWhenSuspended: "Die Abholzeit kann nur im Status \"Zurückgestellt\" geändert werden.",
    pleaseEnterPickupDate: "Bitte ein Abholdatum eingeben",
    pickupDateMustBeTodayOrTomorrow: "Für vom Kellner erstellte Bestellungen ist nur heute oder morgen als Abholdatum erlaubt.",
    normalOrderCreationUnavailableTitle: "Normale Bestellungen sind derzeit nicht verfügbar",
    normalOrderCreationClosedAllDay: "Das Restaurant ist an diesem Tag geschlossen, daher können keine Bestellungen erstellt werden.",
    normalOrderCreationClosedAtThisTime: "Das Restaurant ist derzeit geschlossen. Bestellungen können während der Öffnungszeiten erstellt werden: {{hours}}.",
    waiterOrderNoAvailableOpenSlot: "Für die aktuell erlaubten Tage ist innerhalb der Restaurant-Öffnungszeiten kein gültiger {{orderType}}-Zeitpunkt verfügbar.",
    pickupDateOutsideOpeningHours: "Das gewählte Datum liegt außerhalb der erlaubten Öffnungstage für {{orderType}}-Bestellungen.",
    pickupTimeOutsideOpeningHours: "Die gewählte Uhrzeit liegt außerhalb der erlaubten Öffnungszeiten für {{orderType}}-Bestellungen.",
    openingHoursSelectableRangeHint: "Für {{date}} kann die {{orderType}}-Zeit zwischen {{start}} und {{end}} gewählt werden.",
    openingHoursClosedDayHint: "{{date}} ist für {{orderType}}-Bestellungen geschlossen.",
    openingHoursClosedDayCalendarHint: "Für diesen Bestelltyp geschlossen",
    openingHoursDisabledDatesHint: "Es können nur Tage gewählt werden, an denen innerhalb der Restaurant-Öffnungszeiten mindestens ein {{orderType}}-Zeitpunkt verfügbar ist.",
    openingHoursUnavailableTimesHint: "Nicht auswählbare Uhrzeiten liegen am gewählten Tag außerhalb der Restaurant-Öffnungszeiten für {{orderType}}-Bestellungen.",
    deliveryAndPickupOrders: "Liefer- und Abholbestellungen",
    orderId: "Bestellnummer",
    orderStatus: "Bestellstatus",
    waiter: "Kellner",
    fromCustomerApp: "Aus der Kunden-App",
    orderType: "Bestelltyp",
    payByLink: "Per Link zahlen",
    sendDelivery: "Lieferung senden",
    updateDelivery: "Lieferung aktualisieren",
    requestCourier: "Kurier anfordern",
    sendCourierRequest: "Kurieranfrage senden",
    sentToCourier: "An den Kurierdienst gesendet",
    callCourier: "Kurier anrufen",
    somethingWentWrong: "Etwas ist schiefgelaufen.",
    noPickupTimeProvidedForThisOrder: "Für diese Bestellung ist keine Abholzeit angegeben.",
    pickupTimeCalculationForThisOrderFailed: "Die Berechnung der Abholzeit für diese Bestellung ist fehlgeschlagen.",
    itemEditFailed: "Bearbeiten des Artikels fehlgeschlagen",
    thisItemCannotBeEdited: "Dieser Artikel kann nicht bearbeitet werden.",
    problemInReadingItemEssentialDataMessage: "Beim Lesen wichtiger Artikelinformationen ist ein Problem aufgetreten.",
};

export default de;
